<template>
  <div class="doctorpc-record">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="form-box">
        <div class="docpc-form-title">
          项目医生备案
        </div>
        <van-tabs v-model="tabActive" class="docpc-tabs-card" type="card">
          <van-tab title="文件下载">
            <div class="record-list">
              <div class="list-item" v-for="(ritem, rindex) in record_list" :key="rindex">
                <div class="attach-view">
                  <div class="hd">
                    <van-image width="100" height="100" :src="ritem.sample_image" fit="contain" @click="preview(ritem.sample_image)" />
                  </div>
                  <div class="bd">
                    <div class="attach-label">{{ritem.label}}</div>
                    <div class="attach-desc">{{ritem.desc}}</div>
                  </div>
                  <div class="ft">
                    <van-button :color="themeColor" block size="small"  @click="preview(ritem.sample_image)">预览</van-button>
                    <van-button :color="themeColor" block plain size="small"  @click="save(ritem)">保存</van-button>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="上传">
            <template v-if="showUpload">
              <div class="record-list">
                <div class="tips-msg msg-page">
                  <div class="msg-bd">
                    <div class="title">&nbsp;&nbsp;&nbsp;您已通过援助项目的培训考试，现需要您上传备案文件图片，备案表和备忘录均需上传（备案文件可通过左侧下载），请在下方上传</div>
                    <div class="desc">《医生理解备忘录》、《项目医生备案表》填写完整后，电子备案文件请通过下方进行上传，项目办将在线审核，审核通过后为您制作“项目专用章”，原件请您邮寄到以下地址：北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递），项目联系电话：010-56592455，感谢您的配合与支持！</div>
                  </div>
                </div>
                <div class="list-item" v-for="(upitem, upindex) in upload_list" :key="upindex">
                  <upload-attach :item="upitem" type="record" @confirm="attachConfirm"></upload-attach>
                </div>
              </div>
              <div class="docpc-form-btn" style="margin-top: 20px;">
                <div class="btn-item">
                  <van-button :color="themeColor" block size="small" :disabled="btnDisabled" @click="submit()">提交</van-button>
                </div>
              </div>
            </template>
            <div v-else class="docpc-msg msg-page">
              <div class="msg-hd">
                <div class="msg-png" style="height: auto;">
                  <img :src="msg.png" alt="">
                </div>
              </div>
              <div class="msg-bd">
                <div class="title" v-html="msg.title"></div>
                <div class="desc" v-html="msg.desc"></div>
              </div>
              <div class="msg-ft">
                <van-button v-for="(item, index) in msgButtons" :key="index" :color="item.color" size="small" @click="item.onClick">
                  {{item.txt}}</van-button>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import iconsuccess from "@/assets/docpc/icon_success.png"
import iconwarn from "@/assets/docpc/icon_warn.png"
import iconerror from "@/assets/docpc/icon_error.png"
import record1 from "@/assets/record_table.png" // 项目医生备案表
import record2 from "@/assets/doctor_record_table.png" // 医生理解备忘录
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import uploadAttach from "@/doctor_pc/components/upload/uploadAttach.vue"
import {doctorStatus} from '@/utils/doctorStatus'

import {
  recordSubmit, doctorGetDetail,
} from '@/api/doctorapi';
import {
  GetDocRecordAttach, GetDocRecordExample,
} from '@/api/api';
import {
  Toast,
  Dialog,
  ImagePreview
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcRecord',
  components: {
    docpcSteps,
    uploadAttach
  },
  data() {
    return {
      themeColor: this.themeColor,
      icon_success: iconsuccess,
      icon_warn: iconwarn,
      icon_error: iconerror,
      stepActive: 1,
      baseFileUrl: this.baseUrl,
      doctorInfo: null,
      btnDisabled: false,
      tabActive: 0,
      msg: {
        png: null,
        title: '',
        desc: '',
      },
      msgButtons: [],
      record_list: [
        {
          label: '医生理解备忘录',
          desc: '《医生理解备忘录》您下载打印后填写完整并加盖医务科或科室章。',
          sample_image: record2
        },
        {
          label: '项目医生备案表',
          desc: '《项目医生备案表》您下载打印后填写完整，并书写多种笔体，方便项目办核对您的签字。',
          sample_image: record1
        },
      ],
      showUpload: true,
      upload_list: [
        {
          label: '备案表&备忘录',
          name: 'record',
          value: [],
          upload_filecount: 9,
        },
      ],
      statusInfo: {
        title: '',
        desc: '',
      }
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  async created() {
    this.getData()
  },
  methods: {
    async getData() {
      await GetDocRecordExample({params:{id:this.docpc.docpcInfo.doctor.id}}).then(res => {
        this.record_list[0].sample_image = this.baseFileUrl + res.data.memo
        this.record_list[1].sample_image = this.baseFileUrl + res.data.example_image
      }).catch(err => {
        Toast(err.response.data.message)
      })
      await doctorGetDetail({params:{id: this.docpc.docpcInfo.doctor.id}}).then(res => {
        console.log('doctorGetDetail', res.data)
        this.statusInfo = doctorStatus(res.data.doctor)
        console.log(this.statusInfo,'doctorStatus医生状态信息');
        this.doctorInfo = res.data.doctor
        this.$nextTick(()=>{
          if (this.doctorInfo.record_status=='未上传') {
            this.showUpload = true
          } else {
            this.showUpload = false
            this.msg.png = this.icon_warn
            let that = this
            if (this.doctorInfo.record_status=='纸质审核通过' && this.doctorInfo.seal_status == '已发放') {
              this.stepActive = 2
              this.msg.png = this.icon_success
              this.msg.title = '纸质材料审核通过'
              this.msg.desc = `尊敬的${this.doctorInfo.name}医生，您好。项目办已经寄出您的“项目专用章“，快递单号为：快递公司：${this.doctorInfo.express_sn}，请您注意查收，查收后请您签署《项目专用章签收回执》，并上传。感谢您的配合与支持。`
              if (this.statusInfo.desc) {
                this.msg.title = this.statusInfo.title
                this.msg.desc = this.statusInfo.desc
              }
              this.msgButtons = [{
                txt: '前往印章接收',
                color: this.themeColor,
                onClick: function(){ return that.$router.replace({name: "docpcSign"});}
              }]
              this.tabActive=1
            } else if (this.doctorInfo.record_status=='已上传') {
              this.msg.title = `电子备案等待审核中<br/>尊敬的${this.doctorInfo.name}医生，您好。您上传的备案材料正在审核中，请耐心等待审核结果，感谢您的配合与支持！`
              if (this.statusInfo.desc) {
                this.msg.title = this.statusInfo.title
                this.msg.desc = this.statusInfo.desc
              }
              this.msgButtons = []
              //   this.msgButtons = [{
              //   txt: '前往备案表',
              //   color: this.themeColor,
              //   onClick: function(){ return that.tabActive=0;}
              // }]
              this.tabActive=1
            } else if (this.doctorInfo.record_status=='电子审核不通过') {
              this.msg.png = this.icon_error
              this.msg.title = `电子备案审核不通过<br/>尊敬的${this.doctorInfo.name}医生，您好。您上传的备案表信息审核未通过，请重新上传！`
              this.msg.desc = `<span style="color:red;">失败原因：${this.doctorInfo.record_reason}</span>`
              if (this.statusInfo.desc) {
                this.msg.title = this.statusInfo.title
                this.msg.desc = this.statusInfo.desc
              }
              this.msgButtons = [{
                txt: '前往备案表',
                color: this.themeColor,
                onClick: this.toList.bind(this)
              }]
              this.tabActive=1
            } else if (this.doctorInfo.record_status=='电子审核通过') {
              this.msg.png = this.icon_success
              this.msg.title = '电子备案审核通过'
              this.msg.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的电子材料审核已通过，请邮寄纸质材料到以下地址：北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递），项目联系电话：010-56592455。`
              if (this.statusInfo.desc) {
                this.msg.title = this.statusInfo.title
                this.msg.desc = this.statusInfo.desc
              }
              this.msgButtons = [{
                txt: '前往备案表',
                color: this.themeColor,
                onClick: function(){ return that.tabActive=0;}
              }]
              this.tabActive=1
            } else if (this.doctorInfo.record_status=='纸质审核不通过') {
              this.msg.png = this.icon_error
              this.msg.title = `纸质材料审核不通过<br/>尊敬的${this.doctorInfo.name}医生，您好。您的纸质材料审核未通过，请重新邮寄纸质材料到以下地址：北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递），项目联系电话：010-56592455。`
              if (this.statusInfo.desc) {
                this.msg.title = this.statusInfo.title
                this.msg.desc = this.statusInfo.desc
              }
              // this.msgButtons = [{
              //   txt: '前往备案表下载',
              //   color: this.themeColor,
              //   onClick: function(){ return that.tabActive=0;}
              // }]
              this.tabActive=1
            } else if (this.doctorInfo.record_status=='纸质审核通过') {
              this.stepActive = 2
              let txt = ''
              if (this.doctorInfo.seal_status == '未制作') {
                txt = '正在'
              } else if (this.doctorInfo.seal_status == '已制作') {
                txt = '已'
              }
              this.msg.png = this.icon_success
              this.msg.title = `纸质材料审核通过<br/>尊敬的${this.doctorInfo.name}医生，您好。您的纸质备案文件项目办已查收并审核通过，项目办${txt}为您制作“项目专用章”。感谢您的配合与支持`
              if (this.statusInfo.desc) {
                this.msg.title = this.statusInfo.title
                this.msg.desc = this.statusInfo.desc
              }
              // this.msgButtons = [{
              //   txt: '确认',
              //   color: this.themeColor,
              //   onClick: function(){ return that.tabActive=0;}
              // }]
              this.tabActive=1
            }
          }
        })
      }).catch(err => {
        Toast(err.response.data.message)
      })
      await GetDocRecordAttach({params:{id:this.docpc.docpcInfo.doctor.id}}).then(res => {
        let value = []
        res.data.forEach(ele => {
          value.push({
            id: ele.id,
            src: ele.image
          })
        });
        this.upload_list[0].value = value
        // this.upload_list[0].upload_filecount = 9 - value.length
      }).catch(err => {
        Toast(err.response.data.message)
      })
    },
    preview(file) {
      let images = []
      images.push(file)
      this.$nextTick(() => {
        ImagePreview(images);
      })
    },
    save(item) {
      fetch(item.sample_image).then(res => res.blob().then(blob => {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(blob);
        var filename = item.label || 'pic';
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }));
    },
    attachConfirm(e) {
      console.log('attachConfirm', e, this.upload_list)
    },
    submit() {
      let that = this
      if (this.upload_list[0].value.length>0) {
        let req = {
          doctor_id: this.doctorInfo.id,
          checkItems: []
        }
        for (let i in this.upload_list[0].value) {
          let ele = this.upload_list[0].value[i]
          if (ele.is_New) {
            req.checkItems.push(ele)
          }
        }
        if (req.checkItems.length==0 && this.doctorInfo.record_status=='电子审核不通过') {
          Dialog.alert({
            message: '请先更新图片，再提交',
            theme: 'round-button',
            confirmButtonText: "确定",
            confirmButtonColor: this.themeColor,
          }).then(() => {
            // on close
          });
          return
        }
        this.btnDisabled = true
        recordSubmit(req).then(res => {
          console.log('recordSubmit', res.data)
          this.msg.png = this.icon_success
          this.msg.title = '提交成功'
          this.msg.desc = `尊敬的${this.doctorInfo.name}医生，您好。您的备案材料已提交，请耐心等待审核结果。`
          this.msgButtons = [{
            txt: '确认',
            color: this.themeColor,
            onClick: function(){ return that.getData();}
          }]
          this.showUpload = false
          this.btnDisabled = false
        }).catch(err => {
          this.btnDisabled = false
          Toast(err.response.data.message)
        })
      } else {
        Toast('请上传备案表')
      }
    },
    toList() {
      this.showUpload = true
      // this.tabActive = 0
    },
  }
}
</script>

<style lang='less'>
.doctorpc-record {
  .record-list {
    .list-item {
      padding: 20px 16px; border-bottom: #eee solid 1px;
      .attach-title {
        font-size: 16px; margin-bottom: 20px;
      }
      .attach-view {
        display: flex; align-items: center;
        .hd {
          margin-right: 30px;
        }
        .bd {
          flex: 1; min-width: 0; margin-right: 50px;
          .attach-label {
            font-size: 16px; margin-bottom: 10px;
          }
          .attach-desc {
            font-size: 12px; color: #666;
          }
        }
        .ft {
          padding: 0 0 0 20px; width: 100px;
          .van-button {
            margin: 10px 0;
          }
        }
        .van-image {
          background: #f3f3f3; box-shadow: 0 0 0 1px #eee;
        }
      }
      &:last-child {
        border-bottom-width: 0;
      }
    }
    .tips-msg {
      .msg-bd {
        margin: 20px; text-align: justify; text-align-last: left;
        .title {
          text-indent: 20px;
        }
        .desc {
          text-indent: 20px; text-align: justify; text-align-last: left;
        }
      }
    }
  }
}
</style>